import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sortColumn", "sortDirection"]

  sort(event) {
    const sortColumn = event.currentTarget.dataset.sortColumn;
    let sortDirection = 'asc';

    this.clearSortedHeaders();

    if (sortColumn === 'title' && (!this.sortColumnTarget.value || this.sortColumnTarget.value !== 'title')) {
      sortDirection = 'desc';
    } else if (this.sortColumnTarget.value === sortColumn) {
      sortDirection = this.sortDirectionTarget.value === 'asc' ? 'desc' : 'asc';
    }

    this.sortColumnTarget.value = sortColumn;
    this.sortDirectionTarget.value = sortDirection;

    this.updateHeaderClass(event.currentTarget, sortDirection);

    this.element.dispatchEvent(new CustomEvent("sort-changed", { 
      bubbles: true,
      detail: { sortColumn, sortDirection }
    }));
  }

  updateHeaderClass(sortedHeader, sortDirection) {
    sortedHeader.classList.add('sorted-header');
    if (sortDirection === 'desc') {
      sortedHeader.classList.add('desc');
    }
  }

  clearSortedHeaders() {
    document.querySelectorAll('.sortable-header').forEach(header => {
      header.classList.remove('sorted-header', 'desc');
    });
  }
}
